<wl-event-v4-registration-custom-reg-field
  [customField]="fieldAndResponse.customField"
  [response]="fieldAndResponse.response"
  (responseChange)="onResponseChange($event)"
  *ngFor="let fieldAndResponse of customFieldsAndResponses"
></wl-event-v4-registration-custom-reg-field>
